import api from "@/api/axios";

const API_URL = "/teams";

// --- Teams API ---
export const getTeams = () => api.get(API_URL);
export const getTeam = (id) => api.get(`${API_URL}/${id}`);
export const createTeam = (team) => api.post(API_URL, team);
export const updateTeam = (id, team) => api.put(`${API_URL}/${id}`, team);
export const deleteTeam = (id) => api.delete(`${API_URL}/${id}`);

// --- Get all users in a team for a session ---
export const getUsersInTeam = (teamId, sessionId) =>
  api.get(`${API_URL}/${teamId}/users`, { params: { session_id: sessionId } });

// --- Get all teams assigned to a session ---
export const getTeamsForSession = (sessionId) =>
  api.get(`/team-sessions/sessions/${sessionId}/teams-details`);
